<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-08 22:05:48
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-18 14:37:17
-->
<template>
    <!-- 修改备注 -->
      <el-dialog width="25%" title="修改备注" :visible.sync="dialogRemarksVisible" :append-to-body='true'>
          <el-input v-model="remarkText" autocomplete="off" type="textarea" maxlength="150"  show-word-limit></el-input>
          <div slot="footer" class="dialog-footer">
                <el-button @click="dialogRemarksVisible = false">取消</el-button>
                <el-button type="primary" @click="referTo">提交</el-button>
            </div>
      </el-dialog>
</template>
<script>
import { selectList } from '@/api/shopManage';
export default {
    name: 'remarkDialog',
    data() {
        return {
            dialogRemarksVisible: false,
            remarkText: '',
            remarkObj: {}
        }
    },
    components: {
        
    },
    props: {
        
    },
    methods: {
        //备注弹框
        remark(val) {
            this.remarkObj = val
            this.remarkText = val.remark
            this.dialogRemarksVisible = true
        },
        //提交备注
        referTo() {
            this.remarkObj.remark = this.remarkText
            this.$emit('saveRemark', this.remarkObj)
        },
        hide() {
            this.dialogRemarksVisible = false;
        }
    }
}
</script>
<style scoped>

</style>